'use strict';

var _ = require('underscore');

/**
 * Takes an object of utilities meant to work on a store and a function ment to get the full shape
 * of the store and then maps the utilities to partials that will always get the full shape of the store
 * 
 * @param  {object} 	storeUtils         	object of utilitiy methods
 * @param  {function} getStoreDataFunc 		function which returns full shape of the store
 * @return {object}                    		matching storeUtils object only partially applied with the result 
 *                                        of calling getStoreDataFunc
 */
module.exports = function bindStoreUtils(storeUtils, getStoreDataFunc) {

  return _.mapObject(storeUtils, function mapBindActionCreator(storeUtil) {
    return function boundStoreUtil() {
      var storeData = getStoreDataFunc();
      var storeUtilArgs = [storeData];
      var args = Array.prototype.slice.call(arguments);
      return storeUtil.apply(null, storeUtilArgs.concat(args));
    };
  });
};
